<!-- This container will contain our map -->
<div id="chart_div"></div>
<!-- This container will contain our table -->
<div id='table_div'></div>